import React, { Component } from "react";
import "./Title.css";

export default function Title(props) {
  return (
    <div
      className="titleDiagram"
      style={{
        width: props.width,
      }}
    >
      {props.title}
    </div>
  );
}
